
/**
 * 操作 localStorage 里对应命名空间的对象
 */
export default function getLS(name) {
  let obj = {
    name: '',
    obj: {},
    hasInit: false,
    init: function (name) {
      if (this.hasInit) return false;
      this.hasInit = true;
      if (!name) {
        console.warn('storage name missed');
        return false;
      }
      this.name = name;
      this.get();
    },
    get: function () {
      this.obj = JSON.parse(localStorage.getItem(this.name));
      if (!this.obj) {
        this.obj = {};
        this.set();
      }
      return this.obj;
    },
    set: function () {
      try {
        localStorage.setItem(this.name, JSON.stringify(this.obj));
      } catch (e) {}
    },
    getItem: function (key) {
      return this.obj[key];
    },
    setItem: function (key, val) {
      this.obj[key] = val;
      this.set();
    },
    removeItem: function (key) {
      delete this.obj[key];
      this.set();
    },
    clear: function () {
      return localStorage.removeItem(this.name);
    }
  };
  if (name) {
    obj.init(name);
    return obj;
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/utils/localStorageItem.js